import {useMutation} from '@apollo/client';
import {userInviteMutations} from 'api';
import {useAlert} from 'hooks/useAlert';
import {AddUserViewModel, InviteMultipleUserToScopeByEmailRequest, ResponseViewModel} from 'models';
import {useEffect} from 'react';

export const useInviteMultipleUserToScopeByEmail = () => {
    const {invokeAlert} = useAlert();
    const [inviteMultipleUserToScopeByEmail, {data, loading}] = useMutation<
        {inviteMultipleUsersToScopeByEmail: ResponseViewModel<string>},
        {request: InviteMultipleUserToScopeByEmailRequest}
    >(userInviteMutations.INVITE_MULTIPLE_USERS_TO_SCOPE_BY_EMAIL);

    useEffect(() => {
        if (!loading && data && data.inviteMultipleUsersToScopeByEmail.statusCode !== 200) {
            invokeAlert(data?.inviteMultipleUsersToScopeByEmail.message);
        }
    }, [data, loading]);

    return {
        inviteMultipleUserToScopeByEmail,
        inviteMultipleUserToScopeByEmailResponse: data?.inviteMultipleUsersToScopeByEmail,
        inviteMultipleUserToScopeByEmailLoading: loading,
    };
};

export const useVerifyUserInvitation = () => {
    const [verifyUserInvitation, {data, loading}] = useMutation<
        {verifyUserInvitation: ResponseViewModel<string>},
        {token: string}
    >(userInviteMutations.VERIFY_USER_INVITATION);

    return {
        verifyUserInvitation,
        verifyUserInvitationResponse: data?.verifyUserInvitation,
        verifyUserInvitationLoading: loading,
    };
};

export const useAddUserIfNotExistAfterInvite = () => {
    const [addUserIfNotExistAfterInvite, {data, loading}] = useMutation<
        {addUserIfNotExistAfterInvite: ResponseViewModel<string>},
        {token: string; input: AddUserViewModel}
    >(userInviteMutations.ADD_USER_IF_NOT_EXIST_AFTER_INVITE);

    return {
        addUserIfNotExistAfterInvite,
        addUserIfNotExistAfterInviteResponse: data?.addUserIfNotExistAfterInvite,
        addUserIfNotExistAfterInviteLoading: loading,
    };
};
